import { YealinkPhoneModelCode, PolycomPhoneModelCode } from '../enums';
import { DeviceMetadata } from '../interfaces';

export const YEALINK_PHONE_METADATA: Record<YealinkPhoneModelCode, DeviceMetadata> = {
  T41: { isPagingAvailable: true, buttonsCount: 15, deviceButtonsCount: 6, hasDedicatedPagingButton: true },
  T43: { isPagingAvailable: true, buttonsCount: 21, deviceButtonsCount: 8, hasDedicatedPagingButton: true },
  T44: { isPagingAvailable: true, buttonsCount: 21, deviceButtonsCount: 8, hasDedicatedPagingButton: true },
  T46: { isPagingAvailable: true, buttonsCount: 27, deviceButtonsCount: 10, hasDedicatedPagingButton: true },
  T53: { isPagingAvailable: true, buttonsCount: 21, deviceButtonsCount: 8, hasDedicatedPagingButton: true },
  T54: { isPagingAvailable: true, buttonsCount: 27, deviceButtonsCount: 10, hasDedicatedPagingButton: true },
  T73: { isPagingAvailable: true, buttonsCount: 49, deviceButtonsCount: 8 },
  T74: { isPagingAvailable: true, buttonsCount: 49, deviceButtonsCount: 10 },
  T77: { isPagingAvailable: true, buttonsCount: 84, deviceButtonsCount: 11 },
  T85: { isPagingAvailable: true, buttonsCount: 84, deviceButtonsCount: 12 },
  T87: { isPagingAvailable: true, buttonsCount: 84, deviceButtonsCount: 11 },
  T88: { isPagingAvailable: true, buttonsCount: 84, deviceButtonsCount: 11 },
};

export const POLYCOM_PHONE_METADATA: Record<PolycomPhoneModelCode, DeviceMetadata> = {
  VVX250: { isPagingAvailable: false, buttonsCount: 4, deviceButtonsCount: 6 },
  VVX350: { isPagingAvailable: false, buttonsCount: 6, deviceButtonsCount: 6 },
  VVX450: { isPagingAvailable: false, buttonsCount: 12, deviceButtonsCount: 12 },
};

export const PHONE_METADATA = { ...YEALINK_PHONE_METADATA, ...POLYCOM_PHONE_METADATA };
